(function () {
  const observedImages = new WeakSet();

  function loadImage(image) {
    if (!image.dataset.sliderSrc) return;

    if (image.dataset.sliderSrcset) {
      image.srcset = image.dataset.sliderSrcset;
      delete image.dataset.sliderSrcset;
    }

    image.src = image.dataset.sliderSrc;
    delete image.dataset.sliderSrc;
    image.fetchPriority = 'high';
  }

  function observeImage(image) {
    if (observedImages.has(image)) return;
    observedImages.add(image);

    const slide = image.closest('.swiper-slide');
    if (!slide) return;

    if (slide.classList.contains('swiper-slide-active')) {
      loadImage(image);
      return;
    }

    const slideObserver = new MutationObserver(() => {
      if (!slide.classList.contains('swiper-slide-active')) return;
      slideObserver.disconnect();
      loadImage(image);
    });

    slideObserver.observe(slide, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function setupSlideshow(slideshow) {
    if (slideshow.dataset.lazySlideshowReady === 'true') return;
    slideshow.dataset.lazySlideshowReady = 'true';

    slideshow.querySelectorAll('img[data-slider-src]').forEach(observeImage);

    const cloneObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('img[data-slider-src]')) observeImage(node);
          node.querySelectorAll('img[data-slider-src]').forEach(observeImage);
        });
      });
    });

    cloneObserver.observe(slideshow, {
      childList: true,
      subtree: true
    });
  }

  function setupAllSlideshows(root) {
    root.querySelectorAll('[data-lazy-slideshow]').forEach(setupSlideshow);
  }

  setupAllSlideshows(document);

  document.addEventListener('shopify:section:load', (event) => {
    setupAllSlideshows(event.target);
  });
})();
